"use client";

import { FC, forwardRef, InputHTMLAttributes } from "react";
import S from "./index.module.scss";
import clsx from "clsx";

interface ICustomInput extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
}

const Input: FC<ICustomInput> = forwardRef<HTMLInputElement, ICustomInput>(
  ({ label, error, required, disabled, ...props }, ref) => {
    return (
      <div className={S.container}>
        <div className={clsx(S.inputWrapper, { [S["inputWrapper--disabled"]]: disabled })}>
          <label className={S.label}>{label}</label>
          <input className={S.input} disabled={disabled} {...props} ref={ref} />
          {required && <span className={S.required}>*</span>}
        </div>
        {error && <span className={S.error}>{error}</span>}
      </div>
    );
  },
);

export default Input;
